import { Reveal } from "./Reveal";

const NODES = [
    [90, 300], [150, 210], [210, 380], [265, 130], [300, 260], [350, 330],
    [400, 150], [455, 300], [500, 390], [520, 210], [610, 330], [650, 180],
    [700, 420], [760, 260], [820, 350], [870, 150], [920, 280], [240, 60],
];
const AHAUS = [400, 205];
const GHH = [575, 118];

function Highlight({ x, y, name, meta, side = "right" }) {
    return (
        <g data-testid="network-highlight">
            <circle cx={x} cy={y} r="22" fill="none" stroke="#4C7FBE" strokeWidth="1" opacity="0.7" />
            <circle cx={x} cy={y} r="34" fill="none" stroke="#4C7FBE" strokeWidth="0.7" opacity="0.35" />
            <line x1={x - 44} y1={y} x2={x - 26} y2={y} stroke="#4C7FBE" strokeWidth="1" />
            <line x1={x + 26} y1={y} x2={x + 44} y2={y} stroke="#4C7FBE" strokeWidth="1" />
            <line x1={x} y1={y - 44} x2={x} y2={y - 26} stroke="#4C7FBE" strokeWidth="1" />
            <line x1={x} y1={y + 26} x2={x} y2={y + 44} stroke="#4C7FBE" strokeWidth="1" />
            <circle cx={x} cy={y} r="5" fill="#4C7FBE" />
            <text
                x={side === "right" ? x + 52 : x - 52}
                y={y - 4}
                textAnchor={side === "right" ? "start" : "end"}
                fontSize="13"
                fontFamily="Schibsted Grotesk, sans-serif"
                fontWeight="700"
                fill="#FFFFFF"
                letterSpacing="0.5"
            >
                {name}
            </text>
            <text
                x={side === "right" ? x + 52 : x - 52}
                y={y + 14}
                textAnchor={side === "right" ? "start" : "end"}
                fontSize="10"
                fontFamily="IBM Plex Mono, monospace"
                fill="#4C7FBE"
                letterSpacing="1.5"
            >
                {meta}
            </text>
        </g>
    );
}

export default function GridNetwork() {
    return (
        <div data-testid="project-network" className="relative overflow-hidden border border-line-navy bg-navy-2">
            <svg viewBox="0 0 1000 480" className="h-auto w-full" role="img" aria-label="Map of AddiGen development locations in Germany and Denmark">
                <g stroke="#24374D" strokeWidth="0.8" fill="none">
                    <path d="M0 120 Q 250 100 500 130 T 1000 110" />
                    <path d="M0 240 Q 300 215 520 250 T 1000 230" />
                    <path d="M0 360 Q 280 335 540 370 T 1000 345" />
                    <path d="M160 0 Q 180 240 150 480" />
                    <path d="M480 0 Q 505 240 470 480" />
                    <path d="M800 0 Q 830 240 790 480" />
                </g>
                <g fill="#68727D">
                    {NODES.map(([x, y], i) => (
                        <circle key={i} cx={x} cy={y} r="2.4" opacity="0.4" />
                    ))}
                </g>
                <g stroke="#4C7FBE" strokeWidth="0.9" opacity="0.45" fill="none">
                    <line x1={AHAUS[0]} y1={AHAUS[1]} x2={GHH[0]} y2={GHH[1]} />
                    <line x1={AHAUS[0]} y1={AHAUS[1]} x2="300" y2="260" />
                    <line x1={AHAUS[0]} y1={AHAUS[1]} x2="455" y2="300" />
                    <line x1={GHH[0]} y1={GHH[1]} x2="650" y2="180" />
                    <line x1={GHH[0]} y1={GHH[1]} x2="520" y2="210" />
                </g>
                <Highlight x={AHAUS[0]} y={AHAUS[1] + 60} name="AHAUS" meta="GERMANY — CAES" side="right" />
                <Highlight x={GHH[0]} y={GHH[1]} name="GREEN HYDROGEN HUB" meta="DENMARK — CAES" side="right" />
            </svg>
            <div className="flex flex-wrap items-center justify-between gap-4 border-t border-line-navy px-6 py-4 sm:px-8">
                <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
                    Development network — North-West Europe
                </p>
                <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-blue-bright">
                    2 markets · 4 developments
                </p>
            </div>
        </div>
    );
}
